function initGuidedSearch() {
  if ($('#guided-search').length == 0) {
    return false;
  }

  const ajax_counter = $('#ajax-list-count');
  $('.guided-experience-options').each(function () {
    if ($(this).children().length < 3) {
      $(this).addClass('guided-grid');
    }
  });

  $(document).ready(function () {
    if (window.location.href.indexOf('?') == -1) {
      clearStorage();
    }

    changeButtons();
    checkURLParams();
  });

  function changeButtons() {
    const url_params = new URLSearchParams(window.location.search);
    const href_skip = $('#guided-skip').attr('href').split('?')[0];
    const href_back = $('#guided-back').attr('href').split('?')[0];
    $('#guided-skip').attr('href', href_skip + '?' + url_params.toString());
    $('#guided-back').attr('href', href_back + '?' + url_params.toString());
  }

  $('.guided-info-icon').on('click', function () {
    $(this).next('.guided-info-content').addClass('active');
    $('.custom-control-label').addClass('hidden');
    $('.guided-info-icon').addClass('hidden');
  });

  $('.guided-info-icon-close').on('click', function () {
    $(this).parent().parent().removeClass('active');
    $('.custom-control-label').removeClass('hidden');
    $('.guided-info-icon').removeClass('hidden');
  });

  $('.terms-list input').on('change', function () {
    const nextButton = $('#guided-next');
    const nextButtonText = $('#guided-next span');
    nextButton.removeClass('active');
    if ($('.terms-list input').is(':checked')) {
      nextButton.addClass('active');
    }
    storeTerms();
    changeURL();
    checkURLParams();

    const dataUrl = $(this).next('label').data('url');
    if (dataUrl != 'continue') {
      $('#ajax-list-count').addClass('hidden');
      nextButton.attr('href', dataUrl);
      nextButtonText.text(fpm001_localize.view_relevant_strategies);
    } else {
      nextButtonText.text(fpm001_localize.next);
      $('#ajax-list-count').removeClass('hidden');
    }
  });

  $(document).on('term-selected', function (e, id) {
    $(id).prop('checked', true);
    storeTerms();
  });

  function clearStorage() {
    sessionStorage.removeItem('terms');
  }

  function checkURLParams() {
    const params = new URLSearchParams(window.location.search);
    const url_values = Object.fromEntries(params);

    let terms = {};
    Object.keys(url_values).forEach(elem => {
      if (elem.startsWith('term-')) {
        const tax = elem.replace('term-', '');
        const tax_terms = url_values[elem].split(',');
        terms[tax] = tax_terms;
      }
    });

    if (!$.isEmptyObject(terms)) {
      sessionStorage.setItem('terms', JSON.stringify(terms));
    }

    checkStoredValues();
  }

  function getStoredValues() {
    const data = {
      'terms': sessionStorage.getItem('terms'),
    }

    return data;
  }

  function checkStoredValues() {
    const stored_values = getStoredValues();

    if (stored_values.terms) {
      const stored_terms = JSON.parse(stored_values.terms);
      setTermsValues(stored_terms);
    }

    getPosts(true);
  }

  function changeURL() {
    const stored_values = getStoredValues();
    const query_params = new URLSearchParams(window.location.search);

    if (stored_values.terms) {
      const terms = JSON.parse(stored_values.terms);
      $.each(terms, function (index, value) {
        query_params.set('term-' + index, value);
      });
    }
    const href = $('#guided-next, #guided-results').data('next');
    $('#guided-next, #guided-results').attr('href', href + '?' + query_params.toString());

    history.replaceState(null, null, '?' + query_params.toString());
  }

  function getCheckedValues(taxonomy, group) {
    let values = [];
    $.each($('div[data-taxonomy="' + taxonomy + '"] ' + group + ':checked'), function () {
      values.push($(this).val());
    });

    return values;
  }

  function storeTerms() {
    const taxonomies = getTaxonomies();
    let terms = {};
    $.each(taxonomies, function (key, value) {
      terms[value] = getCheckedValues(value, '.term-input');
    });

    sessionStorage.setItem('terms', JSON.stringify(terms));
  }

  function getPosts() {
    let data = {
      action: 'get_posts',
      nonce: fpm001_localize.nonce,
      post_type: 'mitigation',
      page_id: fpm001_localize.page_id,
      post_taxonomy: fpm001_ajax_list.post_taxonomy,
      terms: getTerms(),
      posts_per_page: fpm001_ajax_list.posts_per_page,
    };

    $.post(fpm001_localize.ajax_url, data, function (response) {
      if (response.data) {
        ajax_counter.html(response.data.paginate_label ? response.data.paginate_label : '');
      }
    });
  }

  function getTerms() {
    const stored_values = getStoredValues();
    const query_params = new URLSearchParams(window.location.search);

    let allTerms = {};

    if (stored_values.terms) {
      const terms = JSON.parse(stored_values.terms);
      $.each(terms, function (index, value) {
        query_params.set('term-' + index, value);
        if ($('.terms-list input[value="' + value + '"').data('all') != '1') {
          if (value != '') {
            allTerms[index] = value;
          }
        }
      });
    }

    return allTerms;
  }

  function getTaxonomies() {
    const taxonomies = [];
    $('.terms-list').each(function () {
      const taxonomy = $(this).data('taxonomy');
      taxonomies.push(taxonomy);
    });

    return taxonomies;
  }

  function setTermsValues(stored_terms) {
    $.each(stored_terms, function (key, value) {
      const terms = value;
      $.each(terms, function (index, id) {
        $('#' + id).prop('checked', true);
      });
    });
  }

  $('#terms-list-flood-risk input').on('change', function () {
    if ($(this).val() == 'yes') {
      $('#guided-results').removeClass('active');
      $('#terms-list-step-2').addClass('active');
    } else {
      $('#guided-results').addClass('active');
      $('#terms-list-step-2').removeClass('active');
      $('#terms-list-step-2 input:checked').prop('checked', false);
      $('#terms-list-step-3').removeClass('active');
      $('#terms-list-step-3 input:checked').prop('checked', false);
      storeTerms();
      changeURL();
      checkURLParams();
    }
  });

  $('#terms-list-step-2 .terms-list input').on('change', function () {
    $('#guided-results').addClass('active');
    $('#terms-list-step-3').addClass('active');
  });
}

function initGuidedSearchPersona() {
  if ($('#persona-guided-search').length == 0) {
    return false;
  }

  const nextUrl = $('#guided-continue').attr('href');

  $('#persona-list input').on('change', function () {
    $('#guided-continue').addClass('active');
    const dataUrl = $(this).next('label').data('url');
    if (dataUrl == 'continue') {
      $('#guided-continue span').text(fpm001_localize.continue);
      $('#guided-continue').attr('href', nextUrl);
    } else {
      $('#guided-continue span').text(fpm001_localize.view_relevant_strategies);
      $('#guided-continue').attr('href', dataUrl);
    }
  });
}

export { initGuidedSearch, initGuidedSearchPersona }



// WEBPACK FOOTER //
// ./scripts/modules/guided-search.js